module.exports = __webpack_public_path__ + "static/media/zkw.2974601e.png";